import React from 'react';
import { Text } from '@rsos/components/capstone/base';
import { IsFetchingContainer } from './PairAuthorityModal.styles';

const NoAgenciesAvailable = () => (
  <IsFetchingContainer>
    <Text color="secondaryText" size="normal">
      No agencies available for pairing
    </Text>
  </IsFetchingContainer>
);

export default NoAgenciesAvailable;
